<template>
    <form>
        <div class="row q-col-gutter-md">
            <div class="col col-xs-12 col-md-6 col-lg-6">
                <q-input
                    v-model="HelpObj.title"
                    :label="$t('helps.table_titles.title')"
                    lazy-rules
                    :error="HelpObj.errors.has('title')"
                    :error-message="HelpObj.errors.get('title')"
                    :rules="[ val => val && val.length > 0 || $t('helps.table_titles.title') + ' is required!']"
                    color="input-color"
                />
            </div> <!-- TITLE -->
            <div class="col col-xs-12 col-md-6 col-lg-6 input-ltr">
                <div class="col col-xs-12 col-md-6 col-lg-3">
                    <q-select
                        v-model="HelpObj.category_id"
                        :options="categories"
                        option-value="id"
                        option-label="title"
                        :label="$t('helps.table_titles.category.title')"
                        emit-value
                        map-options
                        color="input-color"
                        :error="HelpObj.errors.has('category_id')"
                        :error-message="HelpObj.errors.get('category_id')"
                        :loading="loading"
                    />
                </div>
            </div> <!-- Category title -->
            <div class="col col-xs-12">
                <div>{{$t('helps.table_titles.description')}}:</div>
                <q-editor
                    v-model="HelpObj.description"
                    ref="editor"
                    :dense="$q.screen.lt.md"
                    :toolbar="[
                        [
                            {
                              label: $q.lang.editor.align,
                              icon: $q.iconSet.editor.align,
                              fixedLabel: true,
                              options: ['left', 'center', 'right', 'justify']
                            }
                        ],
                        ['bold', 'italic', 'strike', 'underline'],
                        ['hr', 'link'],
                        ['foreColor', 'backColor'],
                        ['unordered', 'ordered'],
                        ['removeFormat', 'viewsource'],
                        ['undo', 'redo'],
                        ['fullscreen']
                    ]">
                    <template v-slot:foreColor>
                        <q-btn
                            flat
                            no-caps
                            dense
                            style="font-size: 0.7em"
                            icon="fa fa-palette"
                        >
                            <q-tooltip>Fore color</q-tooltip>
                            <q-menu anchor="top left" self="top left">
                                <q-color v-model="foreColor" class="my-picker"></q-color>
                                <q-btn
                                    color="primary"
                                    style="width: 200px"
                                    label="Select"
                                    @click="color('foreColor', foreColor)"
                                />
                            </q-menu>
                        </q-btn>
                    </template>
                    <template v-slot:backColor>
                        <q-btn
                            flat
                            dense
                            no-caps
                            style="font-size: 0.7em"
                            icon="format_paint"
                        >
                            <q-tooltip>Back color</q-tooltip>
                            <q-menu anchor="top left" self="top left">
                                <q-color v-model="backColor" class="my-picker"></q-color>
                                <q-btn
                                    color="primary"
                                    style="width: 200px"
                                    label="Select"
                                    @click="color('backColor', backColor)"
                                />
                            </q-menu>
                        </q-btn>
                    </template>
                </q-editor>
                <p v-if="HelpObj.errors.has('description')" class="text-negative">
                    {{ HelpObj.errors.get('description') }}
                </p>
            </div> <!-- Description -->
            <div class="col col-xs-12 col-sm-6 col-lg-9">
                <q-input
                    v-model="HelpObj.slug"
                    :label="$t('helps.table_titles.slug')"
                    lazy-rules
                    :error="HelpObj.errors.has('slug')"
                    :error-message="HelpObj.errors.get('slug')"
                    :rules="[ val => val && val.length > 0 || $t('helps.table_titles.slug') + ' is required!']"
                />
            </div> <!-- Slug -->
            <div class="col col-xs-12 col-sm-6 col-lg-3">
                <q-input
                    v-model="HelpObj.order"
                    :label="$t('helps.table_titles.order')"
                    lazy-rules
                    :error="HelpObj.errors.has('order')"
                    :error-message="HelpObj.errors.get('order')"
                    :rules="[ val => val >= 0 || $t('helps.table_titles.order') + ' is required!']"
                    type="number"
                />
            </div> <!-- Order -->
            <div class="col-12">
                <q-select
                    :label="$t('helps.table_titles.tags')"
                    v-model="HelpObj.tags"
                    use-input
                    use-chips
                    multiple
                    hide-dropdown-icon
                    input-debounce="0"
                    new-value-mode="add-unique"
                />  <!-- Tags -->
            </div>
        </div>
    </form>
</template>

<script>
import FileUploader from "../components/FileUploader"
import Help from "../models/Help"
import Category from "../models/Category"

export default {
  name: 'Form',
  model: {
    prop: 'HelpObj',
    event: 'change'
  },
  props: {
    HelpObj: {
      type: Object,
      required: true
    }
  },
  computed: {},
  data() {
    return {
        loading: false,
        categories: [],
        foreColor:'',
        backColor:''
    }
  },
  methods: {
      insertImg() {
          const help = this.HelpObj
          const input = document.createElement('input')
          input.type = 'file'
          input.accept = '.png, .jpg'
          input.onchange = _ => {
              const files = Array.from(input.files)
              (new Help).uploadImage(files[0], data => {
                  post.body += '<div align="center"><img src="' + data + '" /></div> <br/>'
              })
          }
          input.click()
      },
      submit() {
          this.$emit('submit')
      },
      addTag(val, done) {
          done(val, 'add-unique')
      },
      selectedFile(file) {
          this.HelpObj.images = []
          this.HelpObj.images = file
      },
      removeFiles(files) {
          files.forEach(file => {
              if (file.id !== undefined)
                  this.HelpObj.removed_images.push(file.id)
          })
      },
      getCategories() {
          this.loading = true
          Category.all('sort=id%7Cdesc&per_page=20', ({data}) => {
              this.categories = data
              this.loading = false
          })
      },
      color (cmd, name) {
          const edit = this.$refs.editor
          edit.caret.restore()
          edit.runCmd(cmd, name, true)
          edit.focus()
      },
  },
    mounted() {
        if (! this.categories.length) {
            this.getCategories()
        }
    },
  components: {FileUploader},
}
</script>

<style scoped>

</style>
